/**
 * Toggles a CSS class to the Body element when the an element is clicked. Calling
 * this function automatically sets up any valid elements which have the relevent selector attribute.
 *
 * All elements with the attribute "data-jm-classonclick" are added, and the class added is the value of
 * this attribute.
 *
 * Additional attributes and values:
 *     "data-jm-classonclick-self"              - Boolean - if set, add class to self, otherwise add to body element.
 *     "data-jm-classonclick-noprop"            - Boolean - if set, ignore clicks on child elements.
 *     "data-jm-classonclick-preventdefault"    - Boolean - if set, add e.preventDefault() to the click event.
 */

import { handleError } from './errors';

// setupClassToggle :: Element a -> Element b
function setupClassToggle(element) {
	const target = element.dataset.jmClassonclickSelf === 'true' ? element : document.body;
	const classToAdd = element.dataset.jmClassonclick;
	target.classList.toggle(classToAdd);
}

// maybePreventDefault :: Event -> Event
function maybePreventDefault(event) {
	const { target } = event;
	if(target.dataset.jmClassonclickPreventdefault) event.preventDefault();
	return event;
}

// processElement :: Element a, Event -> Element b
function processElement(clickedElement, event) {
	maybePreventDefault(event);
	return setupClassToggle(clickedElement);
}

// shouldStopPropogation :: Element, Element -> Boolean
function shouldStopPropogation(target, that) {
	return target.dataset.jmClassonclickNoprop === 'true' && target !== that;
}

// clickHandler :: Event -> Element|False
function clickHandler(e) {
	try {
		const { target } = event;
		if(!shouldStopPropogation(target, this)) return processElement(this, e);
		return false;
	} catch (error) {
		handleError(error);
	}
};

// setupClickHandler :: Element -> Element
function setupClickHandler(element) {
	element.addEventListener('click', clickHandler);
	return element;
}

// init :: _ -> Boolean
export function init() {
	const elements = [].slice.call(document.querySelectorAll('[data-jm-classonclick]'));
	elements.map(setupClickHandler);
	return !!elements.length;
}

export default { init };